/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  BigNumberish,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../common";
import type { Hub, HubInterface } from "../Hub";

const _abi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_hubV1",
        type: "address",
        internalType: "contract IHubV1",
      },
      {
        name: "_nameRegistry",
        type: "address",
        internalType: "contract INameRegistry",
      },
      {
        name: "_migration",
        type: "address",
        internalType: "address",
      },
      {
        name: "_liftERC20",
        type: "address",
        internalType: "contract IERC20Lift",
      },
      {
        name: "_standardTreasury",
        type: "address",
        internalType: "address",
      },
      {
        name: "_inflationDayZero",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_bootstrapTime",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_gatewayUrl",
        type: "string",
        internalType: "string",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "advancedUsageFlags",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "avatars",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "balanceOf",
    inputs: [
      {
        name: "_account",
        type: "address",
        internalType: "address",
      },
      {
        name: "_id",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "balanceOfBatch",
    inputs: [
      {
        name: "_accounts",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "_ids",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "balanceOfOnDay",
    inputs: [
      {
        name: "_account",
        type: "address",
        internalType: "address",
      },
      {
        name: "_id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_day",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    outputs: [
      {
        name: "balanceOnDay_",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "discountCost_",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "burn",
    inputs: [
      {
        name: "_id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_data",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "calculateIssuance",
    inputs: [
      {
        name: "_human",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "calculateIssuanceWithCheck",
    inputs: [
      {
        name: "_human",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "convertDemurrageToInflationaryValue",
    inputs: [
      {
        name: "_demurrageValue",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_dayUpdated",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "convertInflationaryToDemurrageValue",
    inputs: [
      {
        name: "_inflationaryValue",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_day",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "day",
    inputs: [
      {
        name: "_timestamp",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "groupMint",
    inputs: [
      {
        name: "_group",
        type: "address",
        internalType: "address",
      },
      {
        name: "_collateralAvatars",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "_amounts",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "_data",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "inflationDayZero",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isApprovedForAll",
    inputs: [
      {
        name: "_account",
        type: "address",
        internalType: "address",
      },
      {
        name: "_operator",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isGroup",
    inputs: [
      {
        name: "_group",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isHuman",
    inputs: [
      {
        name: "_human",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isOrganization",
    inputs: [
      {
        name: "_organization",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isPermittedFlow",
    inputs: [
      {
        name: "_from",
        type: "address",
        internalType: "address",
      },
      {
        name: "_to",
        type: "address",
        internalType: "address",
      },
      {
        name: "_circlesAvatar",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isTrusted",
    inputs: [
      {
        name: "_truster",
        type: "address",
        internalType: "address",
      },
      {
        name: "_trustee",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "migrate",
    inputs: [
      {
        name: "_owner",
        type: "address",
        internalType: "address",
      },
      {
        name: "_avatars",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "_amounts",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "mintPolicies",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "operateFlowMatrix",
    inputs: [
      {
        name: "_flowVertices",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "_flow",
        type: "tuple[]",
        internalType: "struct TypeDefinitions.FlowEdge[]",
        components: [
          {
            name: "streamSinkId",
            type: "uint16",
            internalType: "uint16",
          },
          {
            name: "amount",
            type: "uint192",
            internalType: "uint192",
          },
        ],
      },
      {
        name: "_streams",
        type: "tuple[]",
        internalType: "struct TypeDefinitions.Stream[]",
        components: [
          {
            name: "sourceCoordinate",
            type: "uint16",
            internalType: "uint16",
          },
          {
            name: "flowEdgeIds",
            type: "uint16[]",
            internalType: "uint16[]",
          },
          {
            name: "data",
            type: "bytes",
            internalType: "bytes",
          },
        ],
      },
      {
        name: "_packedCoordinates",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "personalMint",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "registerCustomGroup",
    inputs: [
      {
        name: "_mint",
        type: "address",
        internalType: "address",
      },
      {
        name: "_treasury",
        type: "address",
        internalType: "address",
      },
      {
        name: "_name",
        type: "string",
        internalType: "string",
      },
      {
        name: "_symbol",
        type: "string",
        internalType: "string",
      },
      {
        name: "_metadataDigest",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "registerGroup",
    inputs: [
      {
        name: "_mint",
        type: "address",
        internalType: "address",
      },
      {
        name: "_name",
        type: "string",
        internalType: "string",
      },
      {
        name: "_symbol",
        type: "string",
        internalType: "string",
      },
      {
        name: "_metadataDigest",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "registerHuman",
    inputs: [
      {
        name: "_inviter",
        type: "address",
        internalType: "address",
      },
      {
        name: "_metadataDigest",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "registerOrganization",
    inputs: [
      {
        name: "_name",
        type: "string",
        internalType: "string",
      },
      {
        name: "_metadataDigest",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "safeBatchTransferFrom",
    inputs: [
      {
        name: "_from",
        type: "address",
        internalType: "address",
      },
      {
        name: "_to",
        type: "address",
        internalType: "address",
      },
      {
        name: "_ids",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "_values",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "_data",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "safeTransferFrom",
    inputs: [
      {
        name: "_from",
        type: "address",
        internalType: "address",
      },
      {
        name: "_to",
        type: "address",
        internalType: "address",
      },
      {
        name: "_id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_value",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_data",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setAdvancedUsageFlag",
    inputs: [
      {
        name: "_flag",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setApprovalForAll",
    inputs: [
      {
        name: "_operator",
        type: "address",
        internalType: "address",
      },
      {
        name: "_approved",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "stop",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "stopped",
    inputs: [
      {
        name: "_human",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "supportsInterface",
    inputs: [
      {
        name: "_interfaceId",
        type: "bytes4",
        internalType: "bytes4",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "toTokenId",
    inputs: [
      {
        name: "_avatar",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "totalSupply",
    inputs: [
      {
        name: "_id",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "treasuries",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "trust",
    inputs: [
      {
        name: "_trustReceiver",
        type: "address",
        internalType: "address",
      },
      {
        name: "_expiry",
        type: "uint96",
        internalType: "uint96",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "trustMarkers",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "previous",
        type: "address",
        internalType: "address",
      },
      {
        name: "expiry",
        type: "uint96",
        internalType: "uint96",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "uri",
    inputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "wrap",
    inputs: [
      {
        name: "_avatar",
        type: "address",
        internalType: "address",
      },
      {
        name: "_amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_type",
        type: "uint8",
        internalType: "enum CirclesType",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "ApprovalForAll",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "operator",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "approved",
        type: "bool",
        indexed: false,
        internalType: "bool",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "PersonalMint",
    inputs: [
      {
        name: "human",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "startPeriod",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "endPeriod",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RegisterGroup",
    inputs: [
      {
        name: "group",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "mint",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "treasury",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "name",
        type: "string",
        indexed: false,
        internalType: "string",
      },
      {
        name: "symbol",
        type: "string",
        indexed: false,
        internalType: "string",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RegisterHuman",
    inputs: [
      {
        name: "avatar",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RegisterOrganization",
    inputs: [
      {
        name: "organization",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "name",
        type: "string",
        indexed: false,
        internalType: "string",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Stopped",
    inputs: [
      {
        name: "avatar",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "StreamCompleted",
    inputs: [
      {
        name: "operator",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "from",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "to",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "ids",
        type: "uint256[]",
        indexed: false,
        internalType: "uint256[]",
      },
      {
        name: "amounts",
        type: "uint256[]",
        indexed: false,
        internalType: "uint256[]",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "TransferBatch",
    inputs: [
      {
        name: "operator",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "from",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "to",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "ids",
        type: "uint256[]",
        indexed: false,
        internalType: "uint256[]",
      },
      {
        name: "values",
        type: "uint256[]",
        indexed: false,
        internalType: "uint256[]",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "TransferSingle",
    inputs: [
      {
        name: "operator",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "from",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "to",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "id",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "value",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Trust",
    inputs: [
      {
        name: "truster",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "trustee",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "expiryTime",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "URI",
    inputs: [
      {
        name: "value",
        type: "string",
        indexed: false,
        internalType: "string",
      },
      {
        name: "id",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "CirclesAddressCannotBeZero",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesAmountMustNotBeZero",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesAmountOverflow",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesArrayMustNotBeEmpty",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesArraysLengthMismatch",
    inputs: [
      {
        name: "lengthArray1",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "lengthArray2",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesAvatarMustBeRegistered",
    inputs: [
      {
        name: "avatar",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesDemurrageAmountExceedsMaxUint190",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "circlesId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesDemurrageDayBeforeLastUpdatedDay",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "circlesId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "day",
        type: "uint64",
        internalType: "uint64",
      },
      {
        name: "lastUpdatedDay",
        type: "uint64",
        internalType: "uint64",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesERC1155CannotReceiveBatch",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesERC1155MintBlocked",
    inputs: [
      {
        name: "human",
        type: "address",
        internalType: "address",
      },
      {
        name: "mintV1Status",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubAvatarAlreadyRegistered",
    inputs: [
      {
        name: "avatar",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubFlowEdgeIsNotPermitted",
    inputs: [
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
      {
        name: "circlesId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubFlowEdgeStreamMismatch",
    inputs: [
      {
        name: "flowEdgeId",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "streamId",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubFlowVerticesMustBeSorted",
    inputs: [],
  },
  {
    type: "error",
    name: "CirclesHubGroupIsNotRegistered",
    inputs: [
      {
        name: "group",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubGroupMintPolicyRejectedBurn",
    inputs: [
      {
        name: "burner",
        type: "address",
        internalType: "address",
      },
      {
        name: "group",
        type: "address",
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "data",
        type: "bytes",
        internalType: "bytes",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubGroupMintPolicyRejectedMint",
    inputs: [
      {
        name: "minter",
        type: "address",
        internalType: "address",
      },
      {
        name: "group",
        type: "address",
        internalType: "address",
      },
      {
        name: "collateral",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "amounts",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "data",
        type: "bytes",
        internalType: "bytes",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubInvalidTrustReceiver",
    inputs: [
      {
        name: "trustReceiver",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubMustBeHuman",
    inputs: [
      {
        name: "avatar",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubNettedFlowMismatch",
    inputs: [
      {
        name: "vertexPosition",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "matrixNettedFlow",
        type: "int256",
        internalType: "int256",
      },
      {
        name: "streamNettedFlow",
        type: "int256",
        internalType: "int256",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubOperatorNotApprovedForSource",
    inputs: [
      {
        name: "operator",
        type: "address",
        internalType: "address",
      },
      {
        name: "source",
        type: "address",
        internalType: "address",
      },
      {
        name: "streamId",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubRegisterAvatarV1MustBeStoppedBeforeEndOfInvitationPeriod",
    inputs: [
      {
        name: "avatar",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesHubStreamMismatch",
    inputs: [
      {
        name: "streamId",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesIdMustBeDerivedFromAddress",
    inputs: [
      {
        name: "providedId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidCirclesId",
    inputs: [
      {
        name: "id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidFunctionCaller",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address",
      },
      {
        name: "expectedCaller",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidParameter",
    inputs: [
      {
        name: "parameter",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidString",
    inputs: [
      {
        name: "str",
        type: "string",
        internalType: "string",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesLogicAssertion",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesProxyAlreadyInitialized",
    inputs: [],
  },
  {
    type: "error",
    name: "CirclesReentrancyGuard",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "ERC1155InsufficientBalance",
    inputs: [
      {
        name: "sender",
        type: "address",
        internalType: "address",
      },
      {
        name: "balance",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "needed",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "tokenId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC1155InvalidApprover",
    inputs: [
      {
        name: "approver",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC1155InvalidArrayLength",
    inputs: [
      {
        name: "idsLength",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "valuesLength",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC1155InvalidOperator",
    inputs: [
      {
        name: "operator",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC1155InvalidReceiver",
    inputs: [
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC1155InvalidSender",
    inputs: [
      {
        name: "sender",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC1155MissingApprovalForAll",
    inputs: [
      {
        name: "operator",
        type: "address",
        internalType: "address",
      },
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
    ],
  },
] as const;

const _bytecode =
  "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";

type HubConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HubConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Hub__factory extends ContractFactory {
  constructor(...args: HubConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _hubV1: AddressLike,
    _nameRegistry: AddressLike,
    _migration: AddressLike,
    _liftERC20: AddressLike,
    _standardTreasury: AddressLike,
    _inflationDayZero: BigNumberish,
    _bootstrapTime: BigNumberish,
    _gatewayUrl: string,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _hubV1,
      _nameRegistry,
      _migration,
      _liftERC20,
      _standardTreasury,
      _inflationDayZero,
      _bootstrapTime,
      _gatewayUrl,
      overrides || {}
    );
  }
  override deploy(
    _hubV1: AddressLike,
    _nameRegistry: AddressLike,
    _migration: AddressLike,
    _liftERC20: AddressLike,
    _standardTreasury: AddressLike,
    _inflationDayZero: BigNumberish,
    _bootstrapTime: BigNumberish,
    _gatewayUrl: string,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      _hubV1,
      _nameRegistry,
      _migration,
      _liftERC20,
      _standardTreasury,
      _inflationDayZero,
      _bootstrapTime,
      _gatewayUrl,
      overrides || {}
    ) as Promise<
      Hub & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Hub__factory {
    return super.connect(runner) as Hub__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HubInterface {
    return new Interface(_abi) as HubInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Hub {
    return new Contract(address, _abi, runner) as unknown as Hub;
  }
}
